import React from 'react';
import Card from './Card';

interface TestimonialCardProps {
  authorName: string;
  authorRole: string;
  authorImage: string;
  content: string;
  className?: string;
}

const TestimonialCard: React.FC<TestimonialCardProps> = ({
  authorName,
  authorRole,
  authorImage,
  content,
  className = ''
}) => {
  return (
    <Card hover={true} className={className}>
      <div className="flex items-center mb-4">
        <div className="flex-shrink-0">
          <img
            src={authorImage}
            alt={authorName}
            className="w-12 h-12 rounded-full object-cover"
          />
        </div>
        <div className="ml-4">
          <h4 className="text-lg font-semibold text-primary">{authorName}</h4>
          <p className="text-gray-600">{authorRole}</p>
        </div>
      </div>
      
      <div className="relative">
        <svg
          className="absolute top-0 left-0 w-8 h-8 text-gray-300 transform -translate-x-2 -translate-y-2"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
        </svg>
        <p className="text-gray-700 italic leading-relaxed pl-6">
          "{content}"
        </p>
      </div>
    </Card>
  );
};

export default TestimonialCard;